import styled from "styled-components";
import UseBreakpoints from "../../hooks/ui/UseBreakpoints";
import WorkScopeElement from "../common/WorkScopeElement";
const WorkScopes = ({ contents }) => {
  const breakpoints = UseBreakpoints();
  return (
    <Div breakpoints={breakpoints} length={contents?.length}>
      {contents?.map((x, idx) => {
        return <WorkScopeElement key={idx} title={x.title} icon={x.icon} />;
      })}
    </Div>
  );
};
export default WorkScopes;
// 줄마다 개수가 고르게 나뉘도록 열 수를 정한다 (예: 10개 → 5열 × 2줄)
const Div = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: ${({ breakpoints, length }) =>
    breakpoints.xxl
      ? `repeat(${Math.ceil(length / Math.floor((length + 4) / 5))}, minmax(0, 1fr))` :
      breakpoints.xl
      ? `repeat(${Math.ceil(length / Math.floor((length + 3) / 4))}, minmax(0, 1fr))` :
      breakpoints.md
      ? `repeat(${Math.ceil(length / Math.floor((length + 2) / 3))}, minmax(0, 1fr))`
      : "repeat(2, minmax(0, 1fr))"};
`;
